module.exports = __webpack_public_path__ + "static/media/shop-history-active-light-icon.2469ef42.svg";